<template>
  <div class="frame16_body">
    <div class="frame16">
      <div class="frame16_top">
        营运能力
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame16_close"
        />
      </div>
      <div class="frame16_content">
        <div class="frame16_content_title">存货周转率</div>
        <div class="frame16_content_text">
          【释义】：存货周转率是指一定时期内企业销售成本与存货平均资金占用额的比率，用与反映存货的周转速度、存货占用水平。一般来讲，存货周转速度越快，存货的占用水平越低，流动性越强，存货转换为现金或应收账款的速度越快，有利于提高企业的变现能力。
        </div>
        <div class="frame16_content_text">【算法】： 存货周转率（次数）=营业成本*2/期初存货+期末存货 存货周转率（天数）=A/存货周转次数 注：一季报A=90; 中报A=180； 三季报A=270； 年报A=360 </div>
        <div class="frame16_content_text">【单位】：-/天</div>
      </div>
      <div class="frame16_content">
        <div class="frame16_content_title">应收账款周转率</div>
        <div class="frame16_content_text">
          【释义】：应收账款周转率是报告期内应收账款转为现金的平均次数。应收账款周转率越高，平均收现期越短，说明应收账款的回收越快。 
        </div>
        <div class="frame16_content_text">【算法】：应收账款周转率=营业收入*2/（期初应收账款账面价值+期末应收账款账面价值）</div>
        <div class="frame16_content_text">【单位】：次</div>
      </div>
      <div class="frame16_content">
        <div class="frame16_content_title">总资产周转率</div>
        <div class="frame16_content_text">
          【释义】：总资产周转率是企业一定时期的销售收入净额与平均资产总额之比，它是衡量资产投资规模与销售水平之间配比情况的指标。总资产周转率越高，说明企业销售能力越强，资产投资的效益越好。
        </div>
        <div class="frame16_content_text">【算法】：总资产周转率（次数）=营业总收入*2/（起初资产总计+期末资产总计）</div>
        <div class="frame16_content_text">【单位】：次</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame16_close() {
      this.$emit("frame16_close");
    },
  },
};
</script>

<style scoped>
.frame16_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame16 {
  width: 448px;
  height: 900px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame16_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame16_content {
  margin-top: 28px;
}
.frame16_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame16_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame16_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>